export enum SystemInfoAppTypeEnum {
    ELECTRON = 'Electron',
    CAPACITOR = 'Capacitor',
    WEB_APP = 'WebApp',
}
